/// <reference path="ActivePlazasList.js" />

var InventoryListInstance = undefined;

class InventoryList extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		InventoryListInstance = this;
	}

	filterForCategory(category) {
		var shoppingCart = document.getElementById("houseInventory-shoppingCart");
		if (category === "Pet") {
			shoppingCart.classList.add("hidden");
		} else {
			shoppingCart.classList.remove("hidden");
			shoppingCart.href = this.options.shopUrl.replace('PLH_PublicShopType', category);
		}

		var newDataUrl = this.options.dataUrl.replace("PLH_inventoryType", category);
		useStore(this.options.storeName).reset(newDataUrl);
	}
}
